import axios, { AxiosResponse } from 'axios';
import type {
  TBatchGallery,
  TDeleteBatchLocationMedia,
} from '../../../types/TBatchGallery';

export const DeleteBatchLocationMedia = async ({
  userAccessToken,
  galleryBatchLocationId,
  mediaIds,
  isUpdating,
}: TDeleteBatchLocationMedia): Promise<{
  status: 'ERROR' | 'SUCCESS';
  data: TBatchGallery | object;
}> => {
  try {
    if (isUpdating) isUpdating(true);

    const { data }: AxiosResponse<TBatchGallery> = await axios.post(
      `${process.env.REACT_APP_SAAS_BATCH_GOOGLE_MODULES}/gallery-batch-locations/manual-delete/${galleryBatchLocationId}`,
      {
        mediaIds,
      },
      {
        headers: {
          Authorization: `Bearer ${userAccessToken}`,
        },
      },
    );

    return {
      status: 'SUCCESS',
      data,
    };
  } catch (err: any) {
    return {
      status: 'ERROR',
      data: err.response.data,
    };
  } finally {
    if (isUpdating) isUpdating(false);
  }
};
